var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 58,
    viewBox: "0 0 19 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(-1095 -718)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1017",
    "data-name": "Ellipse 1017",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(1095 718)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1018",
    "data-name": "Ellipse 1018",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(1099 747)",
    fill: "#06016c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1019",
    "data-name": "Ellipse 1019",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(1101 769)",
    fill: "#06016c"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.76bc31fc.svg";
export { ForwardRef as ReactComponent };